import { render, staticRenderFns } from "./BottomPanel.vue?vue&type=template&id=52dfac98&scoped=true&"
import script from "./BottomPanel.vue?vue&type=script&lang=js&"
export * from "./BottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./BottomPanel.vue?vue&type=style&index=0&id=52dfac98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfac98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
